import LegalForm from './LegalForm';
import FalconCloseButton from '../../../components/common/FalconCloseButton';
import { Modal } from '@/components/common/AppModal';
import type { LegalModalProps } from '../types/purchaseTypes';

function LegalModalContainer({ show, setShow, init = null, onSuccess }: LegalModalProps) {
  const handleClose = () => setShow(false);
  return (
    <Modal
      size="lg"
      show={show}
      className="pb-7 pb-md-0"
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title className="fs-1">
          {init ? 'ویرایش' : 'ثبت'} اطلاعات فاکتور
        </Modal.Title>
        <FalconCloseButton onClick={handleClose} />
      </Modal.Header>

      <Modal.Body className="fs--1">
        <LegalForm init={init} handleClose={handleClose} onSuccess={onSuccess} />
      </Modal.Body>
    </Modal>
  );
};

export default LegalModalContainer;
